// @ts-check
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Box, Avatar as AvatarComponent, Typography } from '@material-ui/core';
import PhotoCameraOutlinedIcon from '@material-ui/icons/PhotoCameraOutlined';

const ProfilePics = ({
  classes,
  isEdit,
  saInitials,
  onLifestylePicSelect,
  onProfilePicSelect,
  profileImageUrl,
  lifestyleImgUrl,
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      className={classes.lifestyleImgSection}
      data-testid="lifestyle"
    >
      {lifestyleImgUrl && <img src={lifestyleImgUrl} alt="lifestyle" className={classes.lifestyleImg} />}
      {isEdit && (
        <AvatarComponent className={classes.lifestyleCam}>
          <PhotoCameraOutlinedIcon fontSize="small" onClick={onLifestylePicSelect} />
        </AvatarComponent>
      )}
      <AvatarComponent className={classes.profileImgSection} data-testid="profile">
        {profileImageUrl && <img src={profileImageUrl} alt="profile" />}
        {!profileImageUrl && (
          <Typography
            variant="inherit"
            className={cx(isEdit && classes.saInitials, !isEdit && classes.saInitialsEdit)}
            data-testid="profile-sa"
          >
            {saInitials}
          </Typography>
        )}
      </AvatarComponent>
      {isEdit && (
        <Box display="flex" className={classes.profileOverlayCam}>
          <PhotoCameraOutlinedIcon fontSize="medium" className={classes.profileCam} onClick={onProfilePicSelect} />
        </Box>
      )}
    </Box>
  );
};

ProfilePics.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  isEdit: PropTypes.bool,
  saInitials: PropTypes.string,
  onLifestylePicSelect: PropTypes.func,
  onProfilePicSelect: PropTypes.func,
  profileImageUrl: PropTypes.string,
  lifestyleImgUrl: PropTypes.string,
};

ProfilePics.defaultProps = {
  classes: {},
  isEdit: false,
  saInitials: '',
  onLifestylePicSelect: () => {},
  onProfilePicSelect: () => {},
};

export default ProfilePics;
